/* Modules are returned from this helper function, it returns any module with type and data that it's passed on */
import React, { createContext, useContext } from "react";
import Module from "components/modules";
import { useSiteSnippets } from "context/site-settings";
import pageHasH1, { expandSnippetModules } from "helpers/page-has-h1";

const PageHasH1Context = createContext(undefined);

const RenderModules = ({ modules }) => {
    const snippets = useSiteSnippets();
    const inheritedPageHasH1 = useContext(PageHasH1Context);

    if (!modules) return null;

    const hasH1 = inheritedPageHasH1 !== undefined
        ? inheritedPageHasH1
        : pageHasH1(expandSnippetModules(modules, snippets));

    return (
        <PageHasH1Context.Provider value={hasH1}>
            {modules?.map((module) => (
                <Module
                    key={module._key}
                    type={module._type}
                    moduleData={module}
                    pageHasH1={hasH1}
                />
            ))}
        </PageHasH1Context.Provider>
    );
};

export default RenderModules;
